import {ISlideStream} from 'shared/collections/SlideStream';
import moment from 'moment';
import {RRule} from 'rrule';

export default (slideStream: ISlideStream | undefined) => {
	if (!slideStream || !Array.isArray(slideStream.schedules)) return '';

	const now = moment();
	let slideshowNumId = slideStream.defaultSlideShowNumId || '';

	// Use 'some' instead of 'forEach' to break iteration early if we find slideshow
	slideStream.schedules.some((event) => {
		const mStart = moment(event.startDate);
		const mEnd = moment(event.endDate);

		if (event.allDay && now.isSame(moment(event.date), 'day')) {
			slideshowNumId = event.slideshowNumId;
			return true;
		}

		if (now.isBetween(mStart, mEnd, 'seconds', '[]')) {
			slideshowNumId = event.slideshowNumId;
			return true;
		}

		if (event.rRule) {
			const parsedRRule = RRule.fromString(event.rRule);
			const [dateToCheck] = parsedRRule.between(
				event.allDay ? new Date(event.date!) : event.startDate,
				now.toDate(),
			);

			if (!dateToCheck) return false;

			if (event.allDay && dateToCheck) {
				slideshowNumId = event.slideshowNumId;
				return true;
			}

			// As event can be settled on more than one day (because of timezone or long event duration – >24h)
			// we need to make shift for base start and end dates and check if now is between it
			const daysPassed = now.diff(mStart, 'days');
			const shiftedMStart = moment(mStart).add(daysPassed, 'days');
			const shiftedMEnd = moment(mEnd).add(daysPassed, 'days');

			if (now.isBetween(shiftedMStart, shiftedMEnd, 'seconds', '[]')) {
				slideshowNumId = event.slideshowNumId;
				return true;
			}

			return false;
		}

		return false;
	});

	return slideshowNumId;
};
